// Configuration for Vibes AI Frontend

// Production backend URL (update this with your actual backend URL)
const BACKEND_URL = 'https://vibes-ai-backend.onrender.com';

// Development backend URL
const DEV_BACKEND_URL = 'http://localhost:8080';

// Determine which URL to use based on environment
const isDevelopment = import.meta.env.DEV;
const isDeployed = window.location.hostname.includes('pages.dev') || window.location.hostname.includes('netlify.app') || window.location.hostname.includes('vercel.app');

// Use production backend for deployed frontend, and dev URL for local
const baseUrl = isDevelopment ? DEV_BACKEND_URL : BACKEND_URL;

export function buildApiUrl(endpoint) {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${baseUrl}/${cleanEndpoint}`;
}

export const config = {
  backendUrl: baseUrl,
  isDevelopment,
  isDeployed,
  version: '1.0.0',
  appName: 'Vibes AI'
}; 